// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/edit-outlined-24px.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.custom-table .header {
  display: flex;
  margin-bottom: 20px;
  justify-content: flex-end;
}
.custom-table .header input {
  width: 300px;
}
.custom-table .header .action {
  align-self: flex-end;
}
.custom-table .custom-footer {
  display: flex;
  justify-content: space-between;
}
.custom-table .custom-footer .total {
  font-weight: bold;
}
.custom-table .custom-footer .pagination li {
  background: #f5f6f8;
  color: #323a46;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 2px;
  cursor: pointer;
}
.custom-table .custom-footer .pagination li.active {
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.custom-table .custom-footer .pagination li.disabled {
  opacity: 0.5;
  cursor: no-drop;
}
.custom-table table thead th {
  cursor: pointer;
}
.custom-table table tbody td {
  width: auto;
}
.custom-table table tbody td:last-child {
  text-align: right;
}

.by-switch {
  display: flex;
  flex: 1 1;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.by-switch span {
  margin-left: 10px;
}

.input-filter {
  width: 100%;
}

.multilang-tab {
  border: 0;
}
.multilang-tab + .tab-content {
  padding-top: 0;
}

.preload {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-by-select {
  border: 1px solid var(--bs-border-color);
  min-height: 56px;
  padding-top: 16px;
  padding-right: 28px;
}
.form-by-select.is-invalid {
  border-color: var(--bs-danger);
  padding-right: calc(1.5em + 0.9rem);
}
.form-by-select label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-by-select .react-select > div {
  border: none !important;
}
.form-by-select .react-select__value-container {
  padding-left: 14px;
}
.form-by-select .select-control {
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  border-left: 1px solid var(--bs-border-color);
}
.form-by-select .select-control > div {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.form-by-select .select-control > div:first-child {
  border-bottom: 1px solid var(--bs-border-color);
}

.rst__moveHandle {
  background: #06A6D2 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center !important;
}

.custom-table tbody tr td {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), auto !important;
}

tr.allow-edit {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), auto !important;
}
tr.allow-edit:hover {
  background-color: rgba(55, 205, 230, 0.18);
}

.drag-row-flex {
  display: flex;
  padding: 5px 0;
  width: 100%;
  border-bottom: 1px solid var(--bs-border-color);
}
.drag-row-flex > div {
  display: flex;
  flex: 1 1;
  align-items: center;
}
.drag-row-flex > div:last-child {
  justify-content: flex-end;
}

.selectedClass {
  margin-bottom: 20px;
}

.tagClass {
  background: #23AFD8;
  padding: 5px 0 5px 10px;
  color: white;
  border-radius: 4px;
  margin: 0 5px;
}
.tagClass .removeClass {
  border: none;
  background: none;
  margin-left: 10px;
  color: white;
}

.suggestionsClass {
  border: 1px solid var(--bs-border-color);
  border-top: none;
}
.suggestionsClass ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.suggestionsClass ul li {
  padding: 5px 10px;
  cursor: pointer;
}
.suggestionsClass ul li:hover {
  background: #23AFD8;
  color: white;
}

.body-by-table {
  overflow-x: auto;
}

.estate-image {
  width: 200px;
  height: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.estate-image .overlap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.estate-image .overlap button {
  margin: 2px 0;
}
.estate-image:hover .overlap {
  display: flex;
}
.estate-image .label-status {
  position: absolute;
  bottom: 10px;
  left: 10px;
}
.estate-image .label-status span {
  background: white;
  border-radius: 3px;
  color: black;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  display: block;
  margin-bottom: 2px;
}

.w100 {
  width: 100%;
}

.min-h-500 {
  min-height: 500px;
}

.fancybox__container {
  z-index: 9999 !important;
}

.drag-placeholder {
  border: 1px dashed gray;
}

.draggable-item {
  cursor: move;
  transition: opacity 0.2s, transform 0.2s;
}

.draggable-item.is-dragging {
  opacity: 0.4;
  transform: scale(0.98);
}

.drag-placeholder {
  opacity: 0;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.7;
  }
}
@media (max-width: 500px) {
  .table-response-mobile tr {
    display: block;
    border-bottom-width: var(--bs-border-width);
    padding: 10px;
  }
  .table-response-mobile tr td {
    display: block;
    border: 0;
    position: relative;
    padding: 5px;
  }
  .table-response-mobile tr td::before {
    content: attr(data-label); /* Отримуємо значення з data-label */
    font-weight: bold;
    width: 40%;
    text-align: right;
    margin-right: 10px;
  }
  .estate-image {
    width: 100%;
    margin-right: 0;
  }
  .content-page {
    padding: 70px 0 15px 0;
  }
  .card-body {
    padding: 5px;
  }
  .custom-table .custom-footer {
    display: block;
  }
  .custom-table .custom-footer .total {
    text-align: center;
  }
  .custom-table .custom-footer .pagination {
    display: flex;
    justify-content: center;
  }
  .custom-table .custom-footer .pagination li {
    display: none;
  }
  .custom-table .custom-footer .pagination li:last-child, .custom-table .custom-footer .pagination li:first-child {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/global.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AACJ;AACI;EACE,YAAA;AACN;AAEI;EACE,oBAAA;AAAN;AAIE;EACE,aAAA;EACA,8BAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAMM;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAJR;AAMQ;EACE,wCAAA;EACA,gDAAA;EACA,sDAAA;AAJV;AAOQ;EACE,YAAA;EACA,eAAA;AALV;AAaM;EACE,eAAA;AAXR;AAeM;EACE,WAAA;AAbR;AAeQ;EACE,iBAAA;AAbV;;AAoBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,iBAAA;AAjBJ;;AAqBA;EACE,WAAA;AAlBF;;AAqBA;EACE,SAAA;AAlBF;AAoBE;EACE,cAAA;AAlBJ;;AAsBA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,8BAAA;EACA,mCAAA;AAnBJ;AAsBE;EACE,2CAAA;EACA,8DAAA;AApBJ;AAuBE;EACE,uBAAA;AArBJ;AAwBE;EACE,kBAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,6CAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAvBN;AAyBM;EACE,+CAAA;AAvBR;;AA6BA;EACE,uFAAA;AA1BF;;AAkCM;EACE,gEAAA;AA/BR;;AAqCA;EACE,gEAAA;AAlCF;AAoCE;EACE,0CAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,+CAAA;AAnCF;AAqCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAnCJ;AAqCI;EACE,yBAAA;AAnCN;;AAwCA;EACE,mBAAA;AArCF;;AAwCA;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AArCF;AAuCE;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AArCJ;;AAyCA;EACE,wCAAA;EACA,gBAAA;AAtCF;AAuCE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AArCJ;AAuCI;EACE,iBAAA;EACA,eAAA;AArCN;AAuCM;EACE,mBAAA;EACA,YAAA;AArCR;;AA4CA;EACE,gBAAA;AAzCF;;AA4CA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAzCF;AA2CE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAzCJ;AA2CI;EACE,aAAA;AAzCN;AA8CI;EACE,aAAA;AA5CN;AAgDE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AA9CJ;AAgDI;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA9CN;;AAmDA;EACE,WAAA;AAhDF;;AAmDA;EACE,iBAAA;AAhDF;;AAmDA;EACE,wBAAA;AAhDF;;AAmDA;EACE,uBAAA;AAhDF;;AAmDA;EACE,YAAA;EACA,wCAAA;AAhDF;;AAmDA;EACE,YAAA;EACA,sBAAA;AAhDF;;AAmDA;EACE,UAAA;AAhDF;;AAmDA;EACE;IAAW,YAAA;EA/CX;EAgDA;IAAM,YAAA;EA7CN;AACF;AA+CA;EAEI;IACE,cAAA;IACA,2CAAA;IACA,aAAA;EA9CJ;EAgDI;IACE,cAAA;IACA,SAAA;IACA,kBAAA;IACA,YAAA;EA9CN;EAgDM;IACE,yBAAA,EAAA,oCAAA;IACA,iBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;EA9CR;EAoDA;IACE,WAAA;IACA,eAAA;EAlDF;EAqDA;IACE,sBAAA;EAnDF;EAsDA;IACE,YAAA;EApDF;EAwDE;IACE,cAAA;EAtDJ;EAwDI;IACE,kBAAA;EAtDN;EAyDI;IACE,aAAA;IACA,uBAAA;EAvDN;EAwDM;IACE,aAAA;EAtDR;EAwDQ;IACE,aAAA;EAtDV;AACF","sourcesContent":[".custom-table {\n  .header {\n    display: flex;\n    margin-bottom: 20px;\n    justify-content: flex-end;\n\n    input {\n      width: 300px;\n    }\n\n    .action {\n      align-self: flex-end;\n    }\n  }\n\n  .custom-footer {\n    display: flex;\n    justify-content: space-between;\n\n    .total {\n      font-weight: bold;\n    }\n\n    .pagination {\n      li {\n        background: #f5f6f8;\n        color: #323a46;\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0 2px;\n        cursor: pointer;\n\n        &.active {\n          color: var(--bs-pagination-active-color);\n          background-color: var(--bs-pagination-active-bg);\n          border-color: var(--bs-pagination-active-border-color);\n        }\n\n        &.disabled {\n          opacity: 0.5;\n          cursor: no-drop;\n        }\n      }\n    }\n  }\n\n  table {\n    thead {\n      th {\n        cursor: pointer;\n      }\n    }\n    tbody {\n      td {\n        width: auto;\n\n        &:last-child{\n          text-align: right;\n        }\n      }\n    }\n  }\n}\n\n.by-switch {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n\n  span {\n    margin-left: 10px;\n  }\n}\n\n.input-filter {\n  width: 100%;\n}\n\n.multilang-tab {\n  border: 0;\n\n  &+.tab-content {\n    padding-top: 0;\n  }\n}\n\n.preload {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.form-by-select {\n  border: 1px solid var(--bs-border-color);\n  min-height: 56px;\n  padding-top: 16px;\n  padding-right: 28px;\n\n  &.is-invalid {\n    border-color: var(--bs-danger);\n    padding-right: calc(1.5em + 0.9rem);\n  }\n\n  label {\n    color: rgba(var(--bs-body-color-rgb), 0.65);\n    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  }\n\n  .react-select > div {\n    border: none!important;\n  }\n\n  .react-select__value-container {\n    padding-left: 14px;\n  }\n\n  .select-control {\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n    border-left: 1px solid var(--bs-border-color);\n\n    &>div {\n      width: 28px;\n      height: 28px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n\n      &:first-child {\n        border-bottom: 1px solid var(--bs-border-color);\n      }\n    }\n  }\n}\n\n.rst__moveHandle {\n  background: #06A6D2\n  url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+)\n  no-repeat center!important;\n}\n\n.custom-table {\n  tbody {\n    tr {\n      td {\n        cursor: url(\"../images/edit-outlined-24px.png\"), auto!important;\n      }\n    }\n  }\n}\n\ntr.allow-edit {\n  cursor: url(\"../images/edit-outlined-24px.png\"), auto!important;\n\n  &:hover {\n    background-color: rgba(55, 205, 230, .18);\n  }\n}\n\n.drag-row-flex {\n  display: flex;\n  padding: 5px 0;\n  width: 100%;\n  border-bottom: 1px solid var(--bs-border-color);;\n\n  &>div {\n    display: flex;\n    flex: 1;\n    align-items: center;\n\n    &:last-child {\n      justify-content: flex-end;\n    }\n  }\n}\n\n.selectedClass {\n  margin-bottom: 20px;\n}\n\n.tagClass {\n  background: #23AFD8;\n  padding: 5px 0 5px 10px;\n  color: white;\n  border-radius: 4px;\n  margin: 0 5px;\n\n  .removeClass {\n    border: none;\n    background: none;\n    margin-left: 10px;\n    color: white;\n  }\n}\n\n.suggestionsClass {\n  border: 1px solid var(--bs-border-color);\n  border-top: none;\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      padding: 5px 10px;\n      cursor: pointer;\n\n      &:hover {\n        background: #23AFD8;\n        color: white;\n      }\n\n    }\n  }\n}\n\n.body-by-table {\n  overflow-x: auto;\n}\n\n.estate-image {\n  width: 200px;\n  height: 200px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  position: relative;\n  user-select: none;\n\n  .overlap {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: none;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    button {\n      margin: 2px 0;\n    }\n  }\n\n  &:hover {\n    .overlap {\n      display: flex;\n    }\n  }\n\n  .label-status {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n\n    span {\n      background: white;\n      border-radius: 3px;\n      color: black;\n      font-size: 12px;\n      padding-left: 5px;\n      padding-right: 5px;\n      display: block;\n      margin-bottom: 2px;\n    }\n  }\n}\n\n.w100 {\n  width: 100%;\n}\n\n.min-h-500 {\n  min-height: 500px;\n}\n\n.fancybox__container {\n  z-index: 9999!important;\n}\n\n.drag-placeholder {\n  border: 1px dashed gray;\n}\n\n.draggable-item {\n  cursor: move;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.draggable-item.is-dragging {\n  opacity: 0.4;\n  transform: scale(0.98);\n}\n\n.drag-placeholder {\n  opacity: 0;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 0.4; }\n  50% { opacity: 0.7; }\n}\n\n@media (max-width: 500px) {\n  .table-response-mobile {\n    tr {\n      display: block;\n      border-bottom-width: var(--bs-border-width);\n      padding: 10px;\n\n      td {\n        display: block;\n        border: 0;\n        position: relative;\n        padding: 5px;\n\n        &::before {\n          content: attr(data-label); /* Отримуємо значення з data-label */\n          font-weight: bold;\n          width: 40%;\n          text-align: right;\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n\n  .estate-image {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .content-page {\n    padding: 70px 0 15px 0;\n  }\n\n  .card-body {\n    padding: 5px;\n  }\n\n  .custom-table {\n    .custom-footer {\n      display: block;\n\n      .total {\n        text-align: center;\n      }\n\n      .pagination {\n        display: flex;\n        justify-content: center;\n        li {\n          display: none;\n\n          &:last-child, &:first-child {\n            display: flex;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
